 
import baseApi from './baseApi';
import type { EmployeSignatureGetData, EmployeSignatureGetQuery } from './Schemas/EmployeSignatureGet';
import type { SignerCarteCommand, SignerCarteResponse } from './Schemas/SignerCarte';

const signatureApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    /// NOTE: Voir SignatureSlice pour le matcher lorsque cette requete est reussie
    getEmployeSignature: builder.query<EmployeSignatureGetData, EmployeSignatureGetQuery>({
      query: ({ idUnique }) => `signature/${idUnique}`,
      providesTags: (_result, _error, args) => [{ type: 'EmployesSignature', id: args.idUnique }],
    }),
    signerCarte: builder.mutation<SignerCarteResponse, SignerCarteCommand>({
      query: ({ ...body }) => ({
        url: `signature/${body.idUnique}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, args) => [
        { type: 'EmployesSignature', id: args.idUnique },
      ],
    }),
  }),

});

export const {
  useGetEmployeSignatureQuery,
  useSignerCarteMutation,
} = signatureApi;

export default signatureApi;
